import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7ynhfn3ztz: FaireBrandEntity = {
  token: "b_7ynhfn3ztz",
  type: "brand",
  name: "woolsouk ( We handle U.S. import procedures for you )",
  avatarUrl:
    "https://cdn.faire.com/fastly/f00b2f88ce3ebc894e2edad5a1c4161e4e971f17f0c79cf48048f881e6d977ee.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4948c9d72b9ef4e6f3ceec3dbd53eb709b5f7b8d91c1cebbc53ed5a38ed5f358.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f00b2f88ce3ebc894e2edad5a1c4161e4e971f17f0c79cf48048f881e6d977ee.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4948c9d72b9ef4e6f3ceec3dbd53eb709b5f7b8d91c1cebbc53ed5a38ed5f358.png",
  location: "GBR",
  minimumOrderDollars: 100,
  rating: 4.5,
  reviewCount: 12,
  isTopShop: true,
  isInsider: false,
  description:
    "WoolSouk is a new online brand that sells Moroccan goods with a focus on home decor essentials. Based in Marrakech , WoolSook's goal is to create an amazing brand that carries beautiful home decor essentials at a price that everyone can afford.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:46.042Z",
    importedBy: "entity-db-cli",
  },
};
